<template>

    <div>

        <div class="page light nav-light">

            <div class="header-top">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <ul class="top-nav text-right">
                                <li><a href="https://api.whatsapp.com/send?phone=573147875335&text=Hola%20Comfy"><b>Bogotá:</b> +57 (314) 787 5335</a></li>
                                <li><a href="https://api.whatsapp.com/send?phone=573245311681&text=Hola%20Comfy"><b>Barranquilla:</b> +57 (324) 531 1681</a></li>
                                <li><a href="https://www.facebook.com/comfycol/" target="_blank"><i class="icon icon-facebook"></i></a></li>
                                <li><a href="https://www.instagram.com/comfy_col/" target="_blank"><i class="icon icon-instagram"></i></a></li>
                                <li><a :href="url + '/contactenos'">Contáctanos</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            <nav class="mainnav navbar navbar-default justify-content-between comfy py-2">
                <div class="container">

                    <a class="offcanvas dl-trigger paper-nav-toggle" type="button" data-toggle="offcanvas" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"> <i></i></a>

                    <a class="navbar-brand" :href="url">
                        <img class="d-inline-block align-top" alt="" :src="url + '/frontend/img/comfy/v2/comfy_logotipo_negro.png'" width="190">
                    </a>

                    <div class="paper_menu">
                        <div id="dl-menu" class="xv-menuwrapper responsive-menu">

                            <el-menu class="el-menu-demo dl-menu align-items-center" mode="horizontal" @select="handleSelect">
                                <el-menu-item index="/reservar" class="ivy-bold-italic">Reservar</el-menu-item>
                                <el-menu-item index="/nosotros">Nosotros</el-menu-item>
                                <el-menu-item index="/paquetes">Membresías</el-menu-item>
                                <el-menu-item index="/regalos">Regalar</el-menu-item>
                                <el-submenu index="1">
                                    <template slot="title">
                                        <span class="s-18">Masajes</span>
                                    </template>
                                    <el-menu-item index="/servicios">Técnicas</el-menu-item>
                                    <el-menu-item index="/precios">Precios</el-menu-item>
                                </el-submenu>
                                <el-submenu index="2">
                                    <template slot="title">
                                        <span class="s-18"><i class="el-icon-user-solid text-white"></i> Mi cuenta</span>
                                    </template>
                                    <el-menu-item v-if="authenticate" index="/cliente/perfil">Mi perfil</el-menu-item>
                                    <el-menu-item v-if="authenticate" index="logOut">Cerrar sesión</el-menu-item>
                                    <el-menu-item v-if="!authenticate" index="logIn">Iniciar sesión</el-menu-item>
                                    <el-menu-item v-if="!authenticate" index="singUp">Crear cuenta</el-menu-item>
                                </el-submenu>
                            </el-menu>

                        </div>
                    </div>
                </div>
            </nav>
        </div>
    </div>

</template>

<style type="text/css">
    .el-submenu__icon-arrow.el-icon-arrow-down{
        display: none;
    }
    .el-menu.el-menu--horizontal{
        border-bottom: 0px;
    }
    .el-menu--horizontal > .el-menu-item{
        color: #fff;
        font-size: 18px;
        border-bottom: none;
    }
    .el-menu--horizontal .el-menu--popup .el-menu-item:not(.is-disabled):focus, .el-menu--horizontal .el-menu--popup .el-menu-item:not(.is-disabled):hover {
        color: #fff;
        font-weight: 500;
    }
    ul.el-menu li i {
        padding-right: 0px;
    }
    .el-submenu__title {
        padding: 0 16px;
        line-height: 56px;
    }
    .header-top {
        border-bottom: none;
    }
    .header-top ul.top-nav > li > a {
        padding: 4px 8px;
    }
    .header-top ul.top-nav > li > a > .icon {
        margin-right: 0px;
        padding-right: 0px;
    }
    .el-menu-item {
        font-size: 16px;
        padding: 0px 16px;
    }
    .el-menu {
        background-color: transparent;
    }
    .el-menu--popup {
        background-color: #18333d;
    }
    .el-menu--horizontal .el-menu .el-menu-item{
        background-color: #18333d;
        color: #ffffff;
    }
    .el-menu--horizontal>.el-submenu .el-submenu__title {
        color: #ffffff;
        font-weight: 300;
    }
    .el-menu--horizontal>.el-submenu:hover .el-submenu__title {
        color: #ffffff !important;
        font-weight: 400;
    }
    .el-menu--horizontal>.el-menu-item, .el-menu--horizontal>.el-submenu .el-submenu__title {
        height: 50px;
    }
    .el-submenu [class^=el-icon-] {
        vertical-align: initial;
        margin-right: 0px;
    }
    .el-submenu {
        padding: 0;
    }
</style>

<script>
    export default {
        props: [
            'url', 'auth'
        ],
        data() {
            return {
                fullscreenLoading: false,
                authenticate: this.auth
            }
        },
        methods: {
            modalLogin: function (){
                $('#modalLogin').modal('show')
            },
            modalSignup: function (){
                $('#modalSignUp').modal('show')
            },
            logOut(){
                var url = '/logout'
                // console.log('--- saliendo ---')
                this.fullscreenLoading = true
                this.authenticate = false
                axios.post(url).then(response => {
                    this.fullscreenLoading = false
                    this.$emit('logoutUser', response.data)
                })
            },
            logIn(){
                this.authenticate = true
            },
            handleSelect(key, keyPath) {
                if(key == 'logOut'){
                    this.logOut()
                    return;
                }else if(key == 'logIn'){
                    this.modalLogin()
                    return;
                }else if(key == 'singUp'){
                    this.modalSignup()
                    return;
                }else if(key == '/reservar'){
                    window.location.href = this.url + '/reservar';
                    return;
                }else if(key == '/servicios'){
                    window.location.href = this.url + '/#servicios';
                    return;
                }else if(key == '/precios'){
                    window.location.href = this.url + '/#precios';
                    return;
                }
                // console.log(key)
                // return;
                window.location.href = this.url + key;
            }
        },
        mounted() {
            // console.log('--- componente menú montado ---')
            EventBus.$on('authUser', data => {
                // console.log('--- ejecutando event desde Menu.vue ---')
                this.logIn()
            })
        }
    };
</script>